(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/debounce-input/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/lb-ui/debounce-input/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.ui = svs.ui || {};
svs.lb_ui = svs.lb_ui || {};
svs.lb_ui.debounceInput = svs.lb_ui.debounceInput || {};


 })(window);